import React from "react";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../../../interfaces/api";
import {
  getDoubleDataPPO,
  getDoubleDeepHMO,
} from "../../../functions/planDetails";
import SingleInfoBenefitTripled from "./SingleInfoBenefitTripled.component";
import PPODoubleInfoBenefitTripled from "./PPODoubleInfoBenefitTripled.component";
import comArray from "../../../shared/CompareData";
import comFullArrayEquality from "../../../shared/EqualityArray.component";

interface IProps {
  compData: IFullPlanDetail[] | IFullPlanDetailPPO[];
  highlightDifferences: boolean;
  uniqueName: string;
}

const ComparisonTableVision = (props: IProps) => {
  const plansNumber = props.compData.length;
  const equality = comFullArrayEquality(props.compData);

  const visionEqualityData = equality.find(
    (item) => item.name === props.uniqueName
  );

  const isEyeExamsEqual = visionEqualityData?.childrens.find(
    (item) => item.name === "Eye Exams"
  )?.equal;
  const isEyewearEqual = visionEqualityData?.childrens.find(
    (item) => item.name === "Eye"
  )?.equal;

  return (
    <div
      className="grid-x"
      style={{
        border: "1px solid #D3E1F0",
        backgroundColor: "white",
      }}
    >
      {comArray.map((segment) =>
        segment.name === props.uniqueName
          ? segment.childrens.map((part, index) => (
              <div
                className="grid-x small-12"
                key={index}
                style={{ fontSize: "18px" }}
              >
                <div
                  className={
                    plansNumber === 3 ? "cell small-3" : "cell small-4"
                  }
                  style={{
                    height: "100%",
                    padding: "32px 20px",
                    borderBottom: "1px solid #D3E1F0",
                    textAlign: "start",
                    fontWeight: 600,
                  }}
                >
                  {part.name}
                </div>
                {props.compData.map((plan, index) => (
                  <div
                    className={
                      plansNumber === 3 ? "cell small-3" : "cell small-4"
                    }
                    key={index}
                  >
                    {part.name === "Eye Exams" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isEyeExamsEqual}
                          benefit={getDoubleDeepHMO(
                            plan as IFullPlanDetail,
                            "Vision Services",
                            "Eye Exams (Medicare and Routine)"
                          )}
                        />
                      ) : (
                        <PPODoubleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isEyeExamsEqual}
                          benefit={getDoubleDataPPO(
                            plan as IFullPlanDetailPPO,
                            "Eye Exams (Medicare and Routine)"
                          )}
                        />
                      )
                    ) : null}
                    {part.name === "Eyewear" ? (
                      plan.PlanDetails[0].company[0].healthPlan[0].lob ===
                      "HMO" ? (
                        <SingleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isEyewearEqual}
                          benefit={getDoubleDeepHMO(
                            plan as IFullPlanDetail,
                            "Vision Services",
                            "Eyewear"
                          )}
                        />
                      ) : (
                        <PPODoubleInfoBenefitTripled
                          differences={props.highlightDifferences}
                          equal={isEyewearEqual}
                          benefit={getDoubleDataPPO(
                            plan as IFullPlanDetailPPO,
                            "Eyewear"
                          )}
                        />
                      )
                    ) : null}
                  </div>
                ))}
              </div>
            ))
          : null
      )}
    </div>
  );
};

export default ComparisonTableVision;
